module.exports = __webpack_public_path__ + "static/media/spinner.42f2f683.gif";